import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { Alert, AlertType } from "./Alert";
import { useDelay } from "../hooks";

const sendStateMessages: { [key: string]: {
    msg: string;
    type: AlertType;
    hidden?: boolean;
}} = {
    sending: {
        msg: "Wysyłanie...",
        type: "info"
    },
    completed: {
        msg: "Wysłano poprawnie",
        type: "success"
    },
    error: {
        msg: "Wystąpił błąd podczas wysyłania: ",
        type: "error"
    },
    enqueue: {
        msg: "Dodano do kolejki",
        type: "info"
    },
    none: {
        msg: "",
        type: "info",
        hidden: true
    }
}

export function Printing(props: {
    allowPrint?: boolean,
    copies?: number,
    noAutoCut?: boolean,
    onPrint?: (copies: number, noAutoCut: boolean) => void | Promise<void>;
    onEqueue?: (copies: number, noAutoCut: boolean) => void | Promise<void>;
}) {
    const [copyCount, setCopyCount] = useState(!props.copies ? 1 : props.copies);
    const [noAutoCut, setNoAutoCut] = useState(props.noAutoCut ?? true);
    const [sendState, setSendState] = useState("none");
    const [errorContent, setErrorContent] = useState("");
    const [setSendStateDelay, cancelSendStateDelay] = useDelay();

    useEffect(() => {
        setCopyCount(!props.copies ? 1 : props.copies);
        setNoAutoCut(props.noAutoCut ?? true);
    }, [props.copies, props.noAutoCut]);

    return <div>
        <div>
            {!props.copies ? <span>Ilość kopii: <input type="number" style="margin-left: 10px; width: 60px;" value={copyCount} onChange={(e) => setCopyCount(parseInt(e.currentTarget.value))}/></span> : null }
            {props.noAutoCut === undefined && props.copies !== 1 ? <span style="margin-left: 10px;">Wydrukuj naklejki bez cięcia <input type="checkbox" checked={noAutoCut} onChange={(e) => setNoAutoCut(e.currentTarget.checked)}/></span> : null}
        </div>
        <div style="display: flex; align-items: center; margin-top: 10px">
            <button class={"success" + (!props.allowPrint ? " disabled" : "")}  type="button" style="margin-right: 10px;" onClick={async () => {
                if (props.onPrint && props.allowPrint) {
                    setSendState("sending");

                    try {
                        const ret = props.onPrint(copyCount, noAutoCut);

                        if (ret) {
                            await ret;
                        }

                        setSendState("completed");
                    }
                    catch(ex) {
                        setSendState("error");
                        setErrorContent((ex as any).toString());
                    }
                }
            }}>Wydrukuj</button>
            {props.onEqueue ? <button class="primary" type="button" style="margin-right: 10px;" onClick={async () => {
                if (props.onEqueue) {
                    props.onEqueue(copyCount, noAutoCut);
                    setSendState("enqueue");
                    setSendStateDelay(1500, () => setSendState((prev) => prev === "enqueue" ? "none" : prev));
                }
            }}>Dodaj do kolejki</button>: null}
            <Alert class="send-info" visible={sendStateMessages[sendState].hidden !== true} type={sendStateMessages[sendState].type}>{sendStateMessages[sendState].msg} {sendStateMessages[sendState].type === "error" ? errorContent : ""}</Alert>
        </div>
    </div>;
}
